import { createTheme } from '@mui/material/styles';
import { GOLD, DARK_BG, DARK_CARD } from './constants/colors.js';

const theme = createTheme({
  direction: 'rtl',
  palette: {
    mode: 'dark',
    background: {
      default: DARK_BG,
      paper: DARK_CARD,
    },
    primary: {
      main: '#101012', // Nearly black for AppBar/NavBar
      contrastText: GOLD,
    },
    secondary: {
      main: '#00BFFF',
    },
    error: {
      main: '#FF5252',
    },
    success: {
      main: '#00C853',
    },
    warning: {
      main: '#FF8C00',
    },
    info: {
      main: '#6A5ACD',
    },
    text: {
      primary: '#fff', // Always white for readability
      secondary: GOLD, // Gold accent for secondary text
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;
